let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("DchKe")).then(() => parcelRequire('3T3Pt'));